import React from "react";
import classes from "./styles.module.css";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import {NavLink} from "react-router-dom";
import PcaTable from "../../../Components/PcaTable";

function ContractPca() {

    return (
        <Wrapper>
            <Container className={classes.StackOnMobile}>
                <Column width="780" className={classes.MainColumn}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>Список ПСА для контракта</h5>
                        </div>

                        <div className={classes.TableWrap}>
                            <PcaTable/>
                        </div>
                    </div>
                </Column>

                <Column width="350" className={classes.SideColumn}>
                    <EmptyCard>
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal/contract/1/pca/create`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.pcaCreate"}
                                        icon={"share"}
                                        color={"#3cc23a"}
                                    />
                                </NavLink>
                            </li>

                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.contractsList"}
                                        icon={"share"}
                                        color={"#474545"}
                                    />
                                </NavLink>
                            </li>
                        </ul>
                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default ContractPca;



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/ContractPca/index.js